import { useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useCurrency } from '../contexts/CurrencyContext';
import { formatCurrencyWithName } from '../utils/constants';

/**
 * App-wide currency formatter (replaces local formatCurrencyLocal wrappers).
 * Arabic mode always uses Western digits (latn).
 * @param {string} [languageOverride] — optional language when prop differs from context
 */
export function useFormatCurrency(languageOverride) {
  const { currentLanguage } = useLanguage();
  const { getCurrencyShortName } = useCurrency();
  const lang = languageOverride || currentLanguage;

  return useCallback(
    (amount) => {
      const currencyName = getCurrencyShortName(lang);
      const locale = lang === 'ar' ? 'ar-MR-u-nu-latn' : 'fr-MR';
      return formatCurrencyWithName(amount, locale, currencyName);
    },
    [lang, getCurrencyShortName]
  );
}

export default useFormatCurrency;

